import React, { useContext } from 'react';
import {Button, Card, CardActions, CardContent, CardMedia,  Typography} from '@mui/material';
import { ThemeContext } from '../../context';
import './Proj.css'

const Proj = ({img, name, link, github,description}) => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div style={{paddingTop:'3%'}}>
            <Card className="pj" style={{backgroundColor: darkMode && "rgb(51, 51, 51)",  color: darkMode ? "white":'rgb(43, 39, 39)'}} sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        alt="green iguana"
        height="190"
        image={img}
      />
      <CardContent>
        <Typography style={{fontWeight:'bold', color: darkMode && "white"}} gutterBottom variant="h5" component="div">
          {name}
        </Typography>
        <Typography variant="body2" style={{color: darkMode ? "white":'rgb(43, 39, 39)',textAlign:"start" }} color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      <CardActions style={{paddingLeft:"13%"}}>
      <a style={{textDecoration:"none"}} target="_blank" rel="noreferrer" href={link}>
      <Button className="noselect green button" variant="outlined" style={{fontWeight:'bold', color: darkMode ? "white":'rgb(43, 39, 39)',}} size="small">Live Site</Button>
      </a>
      <a style={{textDecoration:"none"}} target="_blank" rel="noreferrer" href={github}>
      <Button className="noselect blue button" variant="outlined" style={{fontWeight:'bold',  color: darkMode ? "white":'rgb(43, 39, 39)' }} size="small">GitHub</Button>
      </a>
      <a style={{textDecoration:"none"}} href='#home'>
      <Button className="noselect purple button"  variant="outlined" style={{fontWeight:'bold',  color: darkMode ? "white":'rgb(43, 39, 39)'}} size="small">Details</Button>
      </a>
      </CardActions>
    </Card>
        </div>
    );
};

export default Proj;